/* Kaio-Dia - lien "lire la suite" sous l apercu de description.

   L apercu est tronque a deux lignes par le theme. Ce script ajoute dessous
   un lien qui ouvre l onglet Details du produit, plus bas dans la page, et y
   amene le visiteur. Le libelle est celui du theme, deja traduit, passe par
   l attribut data-kd-readmore du bloc d onglets.

   Le lien est ajoute par script et non dans le gabarit : le texte complet est
   deja present dans la page, cet element n est qu une commodite de lecture.

   Repli de largeur : les navigateurs sans :has() n appliquent pas la regle de
   kd-fullwidth.css, on etire donc le bloc parent a la main.

   Fichier maison, jamais ecrase par une mise a jour de FullStack. */
(function () {
  'use strict';

  function openDetails() {
    var tabs = document.getElementById('product-tabs');
    if (!tabs) return;

    var tab = tabs.querySelector('[data-kd-tab="details"]');
    if (tab) tab.click();

    var panel = tabs.querySelector('[data-kd-panel="details"]');
    if (panel && !panel.classList.contains('is-open')) {
      var head = panel.querySelector('[data-kd-panel-toggle]');
      if (head) head.click();
    }

    tabs.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function addLink() {
    var info = document.querySelector('.product-section__product-info');
    var tabs = document.getElementById('product-tabs');
    if (!info || !tabs) return;
    if (info.querySelector('.kd-readmore')) return;

    var desc = info.querySelector(':scope > div.text-block.paragraph');
    if (!desc) return;

    var label = tabs.getAttribute('data-kd-readmore');
    if (!label) return;

    var link = document.createElement('a');
    link.className = 'kd-readmore';
    link.href = '#product-tabs';
    link.textContent = label;
    link.addEventListener('click', function (event) {
      event.preventDefault();
      openDetails();
    });

    desc.insertAdjacentElement('afterend', link);
  }

  function stretchBlocks() {
    if (window.CSS && CSS.supports && CSS.supports('selector(:has(> div))')) return;
    var hooks = document.querySelectorAll('.kd-reviews, .kd-tabs, .kd-details');
    for (var i = 0; i < hooks.length; i++) {
      var parent = hooks[i].closest('.custom-code-block');
      if (parent) {
        parent.style.width = '100%';
        parent.style.alignSelf = 'stretch';
      }
    }
  }

  function boot() {
    addLink();
    stretchBlocks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
